<template>
<body  class="bg-primary">
  <div class="bg-primary" style="width: 100%; min-height:100vh">
    <div class="login-logo q-pt-lg">
      <img class="row col-12 " src="../static/logo_wb.png" style="width:300px;margin: auto;">
    </div>
    <div class="login">
      <div class="login-screen row col-12">
        <div class="col-12 text-center text-primary" style="font-size: 30px;text-align:center;font-weight:600" >物件管理系統</div>
        <!-- <div v-show="!isProd" class="col-12 text-center" style="font-size: 20px; color:red;text-align:center;" >請注意此為測試環境</div> -->
        <div class="col-2"></div>
        <q-input
          class="col-8 login-field"
          dense
          outlined

          v-model="model.userAccount"
          @keyup.enter="$refs.password.focus()"
          placeholder="請輸入帳號"
          :rules="[
            val => !!val || '請輸入帳號',
          ]"
        />
        <!-- <q-input mask="A####" :rules="[val => !!val || '請輸入帳號',val => val.length === 5 || '請確認帳號格式']" /> -->
        <div class="col-2"></div>
        <q-input
          ref ="password"
          class="col-8"
          dense outlined
          v-model="model.password"
          @keyup.enter="$refs.captcha.focus()"
          :type="isPwd ? 'password' : 'text'"
          placeholder="請輸入密碼"
          hint=""
          :error="errorProtein"
          :error-message="errorMessageProtein"
          @blur="proteinRangeValidation(model.password)"
        >
        <template v-slot:append>
          <q-icon
            :name="isPwd ? 'visibility_off' : 'visibility'"
            class="cursor-pointer"
            @click="isPwd = !isPwd"
          />
        </template>
        </q-input>
        <div class="row col-12 items-center">
          <div class="col-2"></div>
          <div class="col-5">
            <q-input
              ref="captcha"
              @keyup.enter="submit"
              outlined
              dense
              :label-width="5"
              placeholder="請輸入圖片中之文字"
              v-model="captcha.inputCaptcha"
              :error="captcha.captchaErrorMessage !== ''"
              :error-message="captcha.captchaErrorMessage"
              mask="####"
              :rules="[
              ]">
            </q-input>
          </div>
          <div class="col-3">
              <img style="width:100%;height:38px;padding: 0px;max-height:40px;max-width:30vw;" :src="captcha.captchaImage">
          </div>
          <!-- 重新產生驗證碼 -->
          <a class="text-blue" style="padding-left:0.5em" @click="getCaptcha()"><i class="fas fa-sync-alt"></i></a>
        </div>

        <div class="row col-12 justify-center items-center">
          <q-btn ref="loginbtn" class="col-8" unelevated rounded color="primary" label="登入" @click="submit()"/>
        </div>
        <div class="col-2"></div>
        <!-- <div class="col-6 justify-center items-center">
          <q-btn class="login-btn" style="padding-bottom:0px" label="忘記密碼" flat color="primary" @click="openForgetPassword()" />
        </div> -->
      </div>
      <!-- 忘記密碼pop up -->
      <q-dialog v-model="forgetPasswordFlag" persistent>
        <q-card style="width: 400px;">
          <q-toolbar class="text-blue-8">
            <q-avatar>
              <q-icon name="fas fa-unlock-alt"></q-icon>
            </q-avatar>
            <q-toolbar-title>
              忘記密碼
            </q-toolbar-title>
          </q-toolbar>
          <q-card-section class="row items-center justify-center">
            <q-input
            class="col-9"
            dense
            outlined
            v-model="forgetPasswordModel.userAccount"
            placeholder="請輸入帳號"
            :rules="[val => !!val || '請輸入帳號']"
            />
            <div class="col-6">
              <q-input
              dense
              outlined
              :label-width="5"
              placeholder="請輸入圖片中之文字"
              v-model="captcha.inputCaptcha"
              :rules="[
              ]"
              :error="captcha.captchaErrorMessage !== ''"
              :error-message="captcha.captchaErrorMessage"
              ></q-input>
            </div>
            <img class="col-3" style="width:90px;height:40px;margin-right:0.5em;margin-bottom: 0.7em;" :src="captcha.captchaImage">
            <div class="col-12 text-blue" style="padding-left:3em" >*密碼將發送至Email信箱</div>
          </q-card-section>
          <q-card-actions align="center">
            <q-btn push class="password-btn" label="取消" color="primary" @click="closeForgotPasswordModel()" />
            <q-btn push class="password-btn" label="確認" color="primary" @click="confirmForgotPassword()" />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
    <div>
    </div>
  </div>
  </body>
</template>

<script>
import { commonMixin } from '@/common/js/mixins'
// import { mapGetters, mapMutations } from 'vuex'
import { Dialog } from 'quasar'

export default {
  name: 'login',
  mixins: [commonMixin],
  mounted () {
    console.log('login mounted ')
    this.getCaptcha()
    // 取得 domain name
    if (window.location.hostname === 'TODO') {
      this.isProd = true
    }
  },
  data () {
    return {
      isProd: false,
      isPwd: true,
      errorProtein: false,
      errorMessageProtein: '',
      model: {
        userAccount: '',
        password: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      forgetPasswordModel: {
        userAccount: ''
      },
      captcha: {
        encodeCaptcha: '',
        inputCaptcha: '',
        captchaImage: '',
        captchaErrorMessage: ''
      },
      forgetPasswordFlag: false
    }
  },
  methods: {
    proteinRangeValidation (val) {
      if (!val) {
        this.errorProtein = true
        this.errorMessageProtein = '請輸入密碼'
        return false
      } else {
        this.errorProtein = false
        this.errorMessageProtein = ''
        return true
      }
    },
    openForgetPassword () {
      this.getCaptcha()
      this.captchaErrorMessage = ''
      this.forgetPasswordModel.userAccount = this.model.userAccount
      this.forgetPasswordFlag = true
    },
    submit () {
      if (this.model.userAccount !== '' && this.model.password !== '') {
        this.validateCaptcha(this.captcha.inputCaptcha, this.captcha.encodeCaptcha).then(response => {
          this.post('login', this.model, r => {
            console.log('r', r.passwordExpired)
            const token = r.tokenType + ' ' + r.accessToken
            localStorage.setItem('token', token)
            this.$http.api.defaults.headers.common['Authorization'] = token
            this.post('getFullUserInfo', { userAccount: this.model.userAccount, systemCode: 'OMS' }, r2 => {
              localStorage.setItem('fullUserInfo', JSON.stringify(r2))
              this.$store.commit('initUserInfo')
              this.$store.commit('setCurrentUserRole')
              if (this.$store.state.currentUserRole) {
                // 判斷是否密碼到期
                console.log('rrrrr', r.passwordExpired)
                if (r.passwordExpired) {
                  console.log('password expired!')
                  console.log('a', this.$route.name)
                  this.$router.push({ name: 'changepassword', params: { routeName: this.$route.name } })
                } else {
                  this.$router.push({ name: 'objectmanage' })
                }
              } else {
                Dialog.create({
                  title: '錯誤訊息',
                  message: '此帳號尚未綁定角色，請洽詢系統管理員'
                })
              }
            })
            // }
          })
        })
      }
    },
    validateCaptcha (captcha, encodeCaptcha) {
      return new Promise((resolve, reject) => {
        if (captcha === '') {
          this.captchaErrorMessage = '請輸入驗證碼'
          reject(this.captchaErrorMessage)
        } else {
          this.get('login/validateCaptcha', { captcha: captcha, encodeCaptcha: encodeCaptcha }, r => {
            if (r === '') {
              this.captchaErrorMessage = ''
              resolve(this.captchaErrorMessage)
            } else {
              this.captchaErrorMessage = '驗證碼輸入錯誤，請重新輸入！'
              reject(this.captchaErrorMessage)
            }
          })
        }
      })
    },
    getCaptcha () {
      this.get('login/getCaptcha', {}, r => {
        let c = r.split('|')
        this.captcha.encodeCaptcha = c[0]
        this.captcha.captchaImage = 'data:image/png;base64,' + c[1]
      })
    },
    confirmForgotPassword () {
      if (this.forgetPasswordModel.userAccount !== '') {
        this.validateCaptcha(this.captcha.inputCaptcha, this.captcha.encodeCaptcha).then(response => {
          console.log(this.forgetPasswordModel.userAccount)
          // TODO 忘記密碼
          // this.get('login/forgetPassword', { userAccount: this.forgetPasswordModel.userAccount }, r => {
          //   this.successMessage('已將變更的密碼寄送至您的信箱!')
          //   this.$router.push({ name: '變更密碼', params: { userAccount: this.forgetPasswordModel.userAccount } })
          // })
        })
      }
    },
    closeForgotPasswordModel () {
      this.forgetPasswordFlag = false
      this.forgetPasswordModel.userAccount = ''
      this.captcha.captchaErrorMessage = ''
      this.captcha.inputCaptcha = ''
      this.getCaptcha()
    }
  }
}
</script>

<style>
.login-btn.q-btn {
  box-shadow: none;
}
.login-field.q-field__control {
  height:40px;
  padding-bottom:0px;
}
.password-btn.q-btn {
  width:100px;
}
</style>
